import { render, staticRenderFns } from "./diaContract.vue?vue&type=template&id=541fb4e0&"
import script from "./diaContract.vue?vue&type=script&lang=js&"
export * from "./diaContract.vue?vue&type=script&lang=js&"
import style0 from "./diaContract.vue?vue&type=style&index=0&id=541fb4e0&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports